import { mapKeysSnakeCase } from "@literati/kids-api";
import {
  requestJSONBasic,
  requestJSON,
  ParsedErrorResponse,
} from "lib/api/base";
import { clearLiteratiUser, setLiteratiUser } from "utils/literatiUser";
import { NEXTJS_BASE_PATH, NEXT_PUBLIC_KIDS_URL } from "globalConfig";
import { GetServerSidePropsContext } from "next";

export interface SocialLoginToken {
  provider: string;
  token: string;
}

/** @todo replace once this endpoint is typed */
export interface Auth {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  isAuthenticated: boolean;
  user: {
    id: number;
    amplitudeId: string;
    email: string;
    isAuthenticated: boolean;
    canLogIn: boolean;
    firstName: string;
    lastName: string;
    phone: string;
    chatJwtToken: string;
    kustomerChatToken: string;
    isAffiliate: boolean;
    socialAccounts: unknown;
  };
}

/**
 * Mirrors the whoami response into `sessionStorage` so the key is present only
 * while the customer is authenticated. This fails closed: an error response
 * clears the key rather than leaving an unverified identity behind.
 */
function syncLiteratiUser(res: Auth | ParsedErrorResponse) {
  if (!res || "error" in res || !res.isAuthenticated || !res.id) {
    clearLiteratiUser();
    return;
  }

  setLiteratiUser({
    id: res.id,
    first_name: res.firstName ?? "",
    last_name: res.lastName ?? "",
  });
}

export async function getAuth(ctx?: GetServerSidePropsContext) {
  const res = (await requestJSON("/api/whoami-next/", undefined, "GET", {
    ctx,
  })) as Auth | ParsedErrorResponse;

  syncLiteratiUser(res);

  return res;
}

export async function loginWithToken(payload: any) {
  return await requestJSON(
    `${NEXT_PUBLIC_KIDS_URL}${NEXTJS_BASE_PATH}/api/login/`,
    payload,
    "POST"
  );
}

export async function linkProvider(payload: any) {
  return await requestJSON("/api/auth/link", payload, "POST");
}

export async function unlinkProvider(payload: any) {
  return await requestJSON("/api/auth/unlink", payload, "POST");
}

export async function logout() {
  const response = await requestJSONBasic(`/api/auth/logout`, null, "POST");
  return response;
}

export async function validatePassword(payload: any) {
  return await requestJSON("/api/auth/token", payload, "POST");
}

export type SetMailingListPayload = {
  mailingList: boolean;
  mailingListDefault?: boolean;
};

export async function setMailingList(
  { mailingList, mailingListDefault = true }: SetMailingListPayload,
  ctx?: GetServerSidePropsContext
) {
  return await requestJSON(
    "/api/auth/set-mailing-list",
    mapKeysSnakeCase({
      mailingList,
      mailingListDefault,
    }),
    "POST",
    { ctx }
  );
}
